import { HTTP } from '../../shared/http-common';
import axios from 'axios';

export default {
    name: 'EmailConfirmed',
    data() {
      return {};
    },
    computed: {
    },
    methods: {
    }
}



// WEBPACK FOOTER //
// ./src/components/EmailConfirmed/EmailConfirmed.js